const { THREE } = window;

export const pathHouse = new THREE.CatmullRomCurve3([
  // Start
  new THREE.Vector3(236807.5352976607, 548506.569323347, 18),
  // Porch
  new THREE.Vector3(236803.02642142653, 548506.1048633029, 17.302031862879257),
  new THREE.Vector3(236801.4279255091, 548505.678488317, 17.302031862879257),
  // Vestibule
  new THREE.Vector3(236799.93517120313, 548506.1980719838, 17.408194299570713),
  new THREE.Vector3(236798.06302556113, 548509.5255735193, 17.400963167968463),
  new THREE.Vector3(236797.4327490857, 548510.0999114728, 17.400963167968463),
  // Hallway
  new THREE.Vector3(236796.04590363303, 548509.9859219295, 17.40511498443567),
  new THREE.Vector3(236794.7902884782, 548508.9612991386, 17.406933820695208),
  new THREE.Vector3(236793.22295282493, 548507.6092211726, 17.40747351932031),
  // Dining room
  new THREE.Vector3(236793.74328830212, 548506.8677024145, 17.390547676272295),
  new THREE.Vector3(236795.1644305253, 548505.2199134697, 17.37258587439457),
  // Anteroom
  new THREE.Vector3(236794.04068929172, 548504.5536274258, 17.436107855953416),
  new THREE.Vector3(236792.59772973476, 548504.0387442488, 17.444752511487984),
  // Sitting room
  new THREE.Vector3(236790.50308656465, 548505.3674511021, 17.402953762303306),
  new THREE.Vector3(236788.65165629506, 548507.7604884158, 17.4077196280419),
  new THREE.Vector3(236786.24725533035, 548506.1595874064, 17.40821782530465),
  // Conservatory
  new THREE.Vector3(236787.10827759598, 548504.3324693877, 17.413708671544237),
  new THREE.Vector3(236788.3716828101, 548502.4130342455, 17.410691847136412),
  // Back to hallway
  new THREE.Vector3(236788.89383884732, 548502.7176261884, 17.443277724061046),
  new THREE.Vector3(236787.18827875177, 548504.4178639468, 17.45558940244936),
  new THREE.Vector3(236787.91721363962, 548506.1916591292, 17.45478667317342),
  new THREE.Vector3(236789.96827091166, 548506.1202665906, 17.45478667317342),
  new THREE.Vector3(236790.87692786692, 548505.0144107599, 17.430380399553616),
  new THREE.Vector3(236792.09020137924, 548506.321288598, 17.430380399553616),
  new THREE.Vector3(236794.41406376305, 548509.1250366134, 17.430380399553616),
  // Kitchen
  new THREE.Vector3(236794.12199535145, 548510.0232022577, 17.403789698606695),
  new THREE.Vector3(236793.8646406367, 548512.252286411, 17.431621954419094),
  new THREE.Vector3(236792.72930680675, 548512.1434918507, 17.47386490408793),
  // Basement stairs (down)
  new THREE.Vector3(236791.69533735793, 548511.668486903, 17.436991657389152),
  new THREE.Vector3(236791.27271642574, 548511.0529045999, 16.91233656883948),
  new THREE.Vector3(236792.13268259092, 548509.8156451853, 15.561146369102206),
  new THREE.Vector3(236792.95187368497, 548508.7359443762, 14.578118073997197),
  // Basement
  new THREE.Vector3(236793.21349358116, 548508.0699254381, 14.540405690776831),
  new THREE.Vector3(236793.5962402473, 548507.8651797876, 14.540405690776831),
  new THREE.Vector3(236793.43229464776, 548508.1200478958, 14.540405690776831),
  // Basement stairs (up)
  new THREE.Vector3(236792.98089674665, 548508.5114882123, 14.640405690776831),
  new THREE.Vector3(236792.5078947368, 548509.3180539754, 15.11399428226733),
  new THREE.Vector3(236791.31989920253, 548511.0268661986, 16.91233656883948),
  // To shed
  new THREE.Vector3(236791.69533735793, 548511.668486903, 17.336991657389152),
  new THREE.Vector3(236792.72930680675, 548512.1434918507, 17.43386490408793),
  new THREE.Vector3(236791.425860628, 548514.1186473562, 17.43046032408345),
  // Shed
  new THREE.Vector3(236791.18633556325, 548515.763171619, 17.47651158043298),
  new THREE.Vector3(236790.1188494419, 548517.5741330944, 17.45029450778349),
  new THREE.Vector3(236790.4941464372, 548517.8246754064, 17.452813163990736),
  // To 2nd floor stairs
  new THREE.Vector3(236791.18633556325, 548515.763171619, 17.47651158043298),
  new THREE.Vector3(236791.425860628, 548514.1186473562, 17.43046032408345),
  new THREE.Vector3(236792.15421974758, 548513.1256270957, 17.436991657389152),
  new THREE.Vector3(236793.8646406367, 548512.252286411, 17.231621954419094),
  new THREE.Vector3(236794.12199535145, 548510.0232022577, 17.203789698606695),
  new THREE.Vector3(236794.0067198862, 548508.735158336, 17.448657160005283),
  new THREE.Vector3(236793.31868815742, 548508.2645252394, 17.61538456634697),
  // 2nd floor stairs
  new THREE.Vector3(236792.35062102415, 548509.6286560759, 18.46130019743084),
  new THREE.Vector3(236790.97081261777, 548511.1775134214, 19.807615762968556),
  new THREE.Vector3(236790.01410767157, 548510.720332948, 19.825562750052378),
  // 2nd floor hallway
  new THREE.Vector3(236791.84024577535, 548508.329343827, 20.162872296289628),
  // Bedroom gemmeker
  new THREE.Vector3(236791.72880324788, 548507.3027009505, 20.175241600528167),
  new THREE.Vector3(236789.3622622637, 548507.2549503102, 20.17403543621491),
  new THREE.Vector3(236789.45498655498, 548506.7683922325, 20.170854101130094),
  new THREE.Vector3(236791.486992268, 548507.4728739185, 20.171989202355345),
  // 2nd floor hallway
  new THREE.Vector3(236792.89637480257, 548508.4747950617, 20.22709853337337),
  new THREE.Vector3(236793.16420850373, 548507.832171622, 20.207334379710316),
  // Bedroom Speck
  new THREE.Vector3(236792.46379408348, 548506.6465627311, 20.207334379710316),
  // new THREE.Vector3(236792.68614119187, 548506.9930798258, 20.20701897663816),
  new THREE.Vector3(236791.86136523756, 548505.6720066112, 20.207334379710316),
  new THREE.Vector3(236791.64148505748, 548503.0435324266, 20.236067651011268),
  new THREE.Vector3(236792.18685662976, 548503.6240219108, 20.236067651011268),
  new THREE.Vector3(236791.86136523756, 548505.6720066112, 20.207334379710316),
  // 2nd floor hallway
  new THREE.Vector3(236792.68614119187, 548506.9930798258, 20.20701897663816),
  // Ironing room
  new THREE.Vector3(236794.1376367667, 548507.6228690218, 20.210496429951928),
  new THREE.Vector3(236795.2071787671, 548505.5331622042, 20.231833331939197),
  new THREE.Vector3(236794.89374185904, 548504.7489735857, 20.24391567124362),
  new THREE.Vector3(236794.39534545655, 548505.1225350093, 20.24391567124362),
  // 2nd floor hallway
  new THREE.Vector3(236794.55291219833, 548506.9680906251, 20.285744269058418),
  new THREE.Vector3(236794.19583432816, 548507.6669910317, 20.21730165402711),
  new THREE.Vector3(236794.93146650842, 548508.4100625855, 20.25621628214384),
  // Guestroom
  new THREE.Vector3(236795.17530871608, 548508.1311500792, 20.25621628214384),
  new THREE.Vector3(236795.5975690618, 548507.8594431708, 20.25621628214384),
  new THREE.Vector3(236796.62980922102, 548508.0767666119, 20.25621628214384),
  new THREE.Vector3(236797.49075315706, 548507.0820286359, 20.288651684243044),
  new THREE.Vector3(236797.7626518534, 548508.6600023733, 20.220475447782927),
  new THREE.Vector3(236796.31646191503, 548508.0030630343, 20.220475447782927),
  // 2nd floor hallway
  new THREE.Vector3(236795.36598605197, 548507.797936969, 20.220475447782927),
  new THREE.Vector3(236794.98902863753, 548508.1393581614, 20.2884809732546),
  new THREE.Vector3(236793.45833198156, 548508.1059768614, 20.25369189929794),
  // Bedroom Elisebeth
  new THREE.Vector3(236793.55213908775, 548510.0374510551, 20.278023879985336),
  new THREE.Vector3(236793.08531137218, 548511.1464081857, 20.194842341860422),
  new THREE.Vector3(236794.29804560178, 548512.5816661271, 20.194842341860422),
  new THREE.Vector3(236794.4773907832, 548512.221617407, 20.194842341860422),
  new THREE.Vector3(236793.16566197248, 548511.6975377371, 20.207109472865893),
  // 2nd floor hallway
  new THREE.Vector3(236793.5597569598, 548510.1685672842, 20.224962327296198),
  new THREE.Vector3(236793.5062092682, 548508.1769727032, 20.28848182378101),
  // Bathroom
  new THREE.Vector3(236795.21851765408, 548508.6704443847, 20.29931026873631),
  new THREE.Vector3(236796.83791908468, 548510.7337376183, 20.230698005336112),
  new THREE.Vector3(236797.2964507847, 548510.4222318168, 20.244386898624263),
  // 2nd floor hallway
  new THREE.Vector3(236795.6121543078, 548508.7845776549, 20.391344761028382),
  new THREE.Vector3(236793.60083904242, 548508.0192390771, 20.52711478890267),
  // Attic Stairs
  new THREE.Vector3(236792.65940765882, 548509.4367872716, 20.661160495422337),
  new THREE.Vector3(236792.33118542656, 548510.0561157771, 21.280654038863002),
  // Attic
  new THREE.Vector3(236791.36471573976, 548510.874667287, 22.87470793972078),
  new THREE.Vector3(236792.21194685236, 548507.9185261682, 23.058413658289517),
]);

export const pathOverview = new THREE.CatmullRomCurve3([
  new THREE.Vector3(237024.38, 548279.81, 972),
  new THREE.Vector3(237011.6, 548395.1, 300),
  new THREE.Vector3(236973.17, 548457.76, 150),
  new THREE.Vector3(236894.04, 548502.64, 50),
  new THREE.Vector3(236830.5, 548504.6, 18),
  new THREE.Vector3(236807.53, 548506.57, 18),
]);
